import Swiper from 'swiper/swiper-bundle';
if (jQuery('.culture__slider').length) {
  var swiper = new Swiper(".culture__swiper", {
    slidesPerView: 1,
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false
    },
    navigation: {
      nextEl: ".culture__slider .swiper-button-next",
      prevEl: ".culture__slider .swiper-button-prev"
    }
  });
}